<h2 mat-dialog-title>{{ 'DIALOG.INFORMATION' | translate }}</h2>
<mat-dialog-content>{{ data.message.message }}</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    color="accent"
    mat-flat-button
    mat-dialog-close>
    {{ data.message.okLabel || 'DIALOG.OK' | translate }}
  </button>
</mat-dialog-actions>
